module.exports = __webpack_public_path__ + "img/1F1EA-1F1F9.160d5ff2.svg";